import * as THREE from 'three';

import { renderOrders } from '../../../render-orders';
// @ts-ignore
import { dxfHelpers } from '../dxfHelpers.js';

type Point = {
  x: number;
  y: number;
  z: number;
};

type DxfProperties = {
  color?: number;
};

type PointData = {
  points: Point[];
  properties?: DxfProperties;
};

export default class DxfPointParser {
  constructor() {
    /*  */
  }

  processPoint(entity: any, insert: any): PointData {
    let position = entity.position || entity;

    if (insert) {
      position = dxfHelpers.transformInsertVertex(insert, position);
    }

    // Return point structure
    return {
      points: [{ x: position.x, y: position.y, z: position.z || 0 }],
    };
  }

  generatePointMaterial(properties?: DxfProperties) {
    return new THREE.PointsMaterial({
      color: properties?.color ?? 0,
      size: 2,
      sizeAttenuation: false,
    });
  }

  generatePoints(pointData: PointData) {
    const points = pointData.points;
    const properties = pointData.properties;

    if (!points || points.length === 0) {
      return null;
    }

    const geometry = new THREE.BufferGeometry();
    const material = this.generatePointMaterial(properties);
    const offset = points[0];

    const vertices = new Float32Array(points.length * 3);
    for (let i = 0; i < points.length; i++) {
      vertices[i * 3] = points[i].x - offset.x;
      vertices[i * 3 + 1] = points[i].y - offset.y;
      vertices[i * 3 + 2] = points[i].z || 0;
    }

    geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
    geometry.computeBoundingSphere();

    const pointCollection = new THREE.Points(geometry, material);
    pointCollection.position.set(offset.x, offset.y, pointCollection.position.z);
    pointCollection.name = 'PointCollection';
    pointCollection.renderOrder = renderOrders.dxfAsset.points;

    return pointCollection;
  }
}
